import {styled} from "@mui/material/styles";
import {TextField} from "@mui/material";

export const InputTextField = styled(TextField)(( { theme } ) => ({
    fontSize: '14px',
    lineHeight: '22px',
}));